import { render } from "./DeclaracoesDocumentos.vue?vue&type=template&id=01a95805&scoped=true"
import script from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"
export * from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"

import "./DeclaracoesDocumentos.vue?vue&type=style&index=0&id=01a95805&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a95805"]])

export default __exports__